import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getAdvertiserHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/advertiser/_layout/transaction/")({
    component: AdvertiserTransactionPage,
    staticData: {
        permissions: [PermissionEnum.AdvertiserTransactionView],
        showInSideMenu: false,
        label: "pages.advertiser.transaction.title",
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.advertiser.transaction.title"),
    }),
});

function AdvertiserTransactionPage() {
    return (
        <TenantPage headerNavigationItems={getAdvertiserHeaderItems}>
            <></>
        </TenantPage>
    );
}
